import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { findRestaurantFromUrl } from "@/graphql/mutations";
import type { RestaurantFromUrl } from "@/API";

const client = generateClient();

export const searchRestaurantWithURLState = create<State<RestaurantFromUrl>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const searchRestaurantWithURLIsloading = () =>
  searchRestaurantWithURLState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const searchRestaurantWithURLURLIsError = (error: Error) =>
  searchRestaurantWithURLState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const searchRestaurantWithURLURLIsSuccess = (
  restaurantDetails: RestaurantFromUrl
) =>
  searchRestaurantWithURLState.setState(() => ({
    data: restaurantDetails,
    isLoading: false,
    error: null,
  }));

export const resetSearchRestaurantWithURLState = () =>
  searchRestaurantWithURLState.setState(() => searchRestaurantWithURLState.getInitialState());

export const searchRestaurantWithURL = async (url: string) => {
  searchRestaurantWithURLIsloading();

  try {
    const { data } = await client.graphql({
      query: findRestaurantFromUrl,
      variables: {
        url,
      },
    });

    searchRestaurantWithURLURLIsSuccess(data.findRestaurantFromUrl);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to mutate findRestaurantFromUrl";
    searchRestaurantWithURLURLIsError(Error(errorMessage));
  }
};
